// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"9a709a5f","127":"64cefb7d","297":"56a06fe5"}[chunkId] + ".chunk.js";
};